/**
 * 通知路由配置
 * 根据消息内容决定跳转的路由和需要执行的操作
 */

import { ROUTER_PATH } from "@config/router";
import { AgentReport } from "@features/api/memberApi";

/**
 * 通知路由配置类型
 */
export interface NotificationRoute {
  /** 目标路由路径 */
  path: string;
  /** 操作类型（用于目标页面识别需要执行的操作） */
  action?: string;
  /** 额外的查询参数 */
  query?: Record<string, string>;
}

/**
 * 根据 AgentReport 消息决定路由配置
 * @param message AgentReport 消息
 * @returns 路由配置
 */
export const getNotificationRoute = (
  message: AgentReport,
): NotificationRoute | null => {
  const agentId = message.agent_id;
  const messageId = message.id;
  // const level = message.level;

  return {
    path: ROUTER_PATH.CHAT,
    query: {
      agentId: "0",
      msgId: messageId ?? "",
      msgAgentId: agentId ?? "",
    },
  };
};

/**
 * 构建完整的路由 URL
 * @param route 路由配置
 * @returns 完整的 URL 字符串
 */
export const buildNotificationUrl = (route: NotificationRoute): string => {
  const { path, action, query = {} } = route;

  // 添加 action 到查询参数
  if (action) {
    query.action = action;
  }

  // 构建查询字符串
  const queryString = Object.entries(query)
    .filter(([_, value]) => value !== undefined && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return queryString ? `${path}?${queryString}` : path;
};
